// extracted by mini-css-extract-plugin
export var advancedIframe = "advancedIframe-module--advancedIframe--f701c";
export var fullScreen = "advancedIframe-module--fullScreen--3c560";
export var inset = "advancedIframe-module--inset--c9d7b";
export var medium = "advancedIframe-module--medium--5dfbf";
export var short = "advancedIframe-module--short--b17a8";
export var tall = "advancedIframe-module--tall--859b2";